module.exports = __webpack_public_path__ + "img/tj.ff40d4cd.png";